<template>
  <section class="tile is-ancestor">
    <div class="tile question-list">
      <div
        v-for="(question, index) in questions"
        :key="index"
        class="tile is-parent question-tile"
        @click="questionClicked(index)"
      >
        <div class="tile is-child box">
          <div class="title is-5">Question #{{ index + 1 }}</div>
          <div class="media">
            <div class="media-content">
              <p class="subtitle is-7">Score</p>
              <p class="title is-6">{{ question.score || '-' }}</p>
            </div>
            <div class="media-content">
              <p class="subtitle is-7">Hops</p>
              <p class="title is-6">{{ question.hops || '-' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section v-if="showModal">
      <b-modal :active.sync="showModal" :width="380" scroll="keep">
        <div class="modal-card history-chat" style="width: auto">
          <header class="modal-card-head history-chat__head">
            <p class="modal-card-title">Question #{{ selectedQuestion + 1 }}</p>
          </header>
          <section class="modal-card-body history-chat__body">
            <div
              :set="
                (history = questions[selectedQuestion].history.chat
                  ? questions[selectedQuestion].history.chat.history
                  : questions[selectedQuestion].history)
              "
            >
              <div
                v-for="(prompt, index) in history"
                :key="index"
                class="message-box"
                :class="[
                  isPromptSent(prompt)
                    ? 'message-box__sent'
                    : 'message-box__received'
                ]"
              >
                <!-- eslint-disable vue/no-v-html -->
                <div
                  class="message-box__bubble"
                  :class="[
                    isPromptSent(prompt)
                      ? 'message-box__bubble__sent'
                      : 'message-box__bubble__received'
                  ]"
                  v-html="marked(parsedGcsUrlInMarkdown(prompt.m))"
                ></div>
                <!-- eslint-enable vue/no-v-html -->
              </div>
            </div>
          </section>
        </div>
      </b-modal>
    </section>
  </section>
</template>

<script>
import marked from 'marked';

import { parsedGcsUrlInMarkdown } from '../../../utils/url';

export default {
  data: function() {
    return {
      showModal: false,
      selectedQuestion: null
    };
  },
  props: {
    questions: Array
  },
  methods: {
    questionClicked(index) {
      this.selectedQuestion = index;
      this.showModal = true;
    },
    isPromptSent(prompt) {
      return prompt.d === 'sent';
    },
    marked,
    parsedGcsUrlInMarkdown
  }
};
</script>

<style lang="scss" scoped>
.question-list {
  overflow: scroll;
  .question-tile {
    min-width: 12rem;
    &:hover {
      cursor: pointer;
    }

    .title:not(:last-child) {
      margin-bottom: 0.8rem;
    }
  }
}

.history-chat {
  border-radius: 6px;
  &__head {
    background-color: $theme-color;
    .modal-card-title {
      color: $light-color;
    }
  }
  &__body {
    background-color: $app-base-background;
  }
}

.message-box {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  &__bubble {
    box-shadow: $theme-background-shadow;
    max-width: 95%;
    padding: 0.7rem;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    display: inline-block;
    line-height: 1.3;
    white-space: pre-line;

    &__sent {
      background-color: $secondary-color;
      border-radius: 15px 0px 15px 15px;
      flex-direction: column-reverse;
    }

    &__received {
      background-color: white;
      border-radius: 0px 15px 15px 15px;
    }
  }
  &__sent {
    flex-direction: row-reverse;
  }
}
</style>
